import { render, staticRenderFns } from "./CounterpartiesComponent.vue?vue&type=template&id=3636c3d8"
import script from "./CounterpartiesComponent.vue?vue&type=script&lang=js"
export * from "./CounterpartiesComponent.vue?vue&type=script&lang=js"
import style0 from "./CounterpartiesComponent.vue?vue&type=style&index=0&id=3636c3d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports